import styled from 'styled-components';
import { colors } from '../../../../utils/utils';

const Text = styled.div`
    font-size: 11px;
    color: ${colors.gray.basic};
`;

export default Text;
